export const common = {
  brand: 'Vitalmedic',
  clinic_name: 'Clínica Vitalmedic Tarija SRL',
  tagline: 'Tu salud, nuestra prioridad',
  phone: '77173439',
  phone_full: '+591 77173439',
  address: 'Junín 1152, atrás del Hospital Regional San Juan de Dios',
  city: 'Tarija, Bolivia',
  hours: '24 horas, los 7 días de la semana',
  email: 'contacto@vitalmedic.com.bo',
  nav_home: 'Inicio',
  nav_about: 'Nosotros',
  nav_services: 'Servicios',
  nav_contact: 'Contacto',
  cta_appointment: 'Solicitar Turno',
  cta_call: 'Llamar Ahora',
  cta_whatsapp: 'WhatsApp',
  footer_rights: 'Todos los derechos reservados',
  footer_address: 'Dirección',
  footer_hours: 'Horarios',
  footer_contact: 'Contacto',
  footer_links: 'Enlaces Rápidos',
};

export default common;